import { render, staticRenderFns } from "./CtrlAddBtn.vue?vue&type=template&id=2b7ca22d&scoped=true&"
import script from "./CtrlAddBtn.vue?vue&type=script&lang=ts&"
export * from "./CtrlAddBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ca22d",
  null
  
)

export default component.exports